import { render, staticRenderFns } from "./EmojiInput.vue?vue&type=template&id=c3688ac8&scoped=true&"
import script from "./EmojiInput.vue?vue&type=script&lang=js&"
export * from "./EmojiInput.vue?vue&type=script&lang=js&"
import style0 from "./EmojiInput.vue?vue&type=style&index=0&id=c3688ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3688ac8",
  null
  
)

export default component.exports